import React from "react";
import ImageTag from "../../reusebale/imageTag";
import ParagraphTag from "../../reusebale/Paragraph";
import moment from "moment";
import { sumByKey } from "../../../utils/subscriptionHelper";

const LandlordInfo = ({ selectedLandlord }) => {
  console.log("selectedLandlord", selectedLandlord);
  return (
    <div className="">
      <div className="bg-white rounded-xl">
        <div className="px-4 pt-4">
          <ParagraphTag
            content="landlord Info"
            classes="text-darkColor font-popinsSemiBold text-base"
          />
        </div>
        <div className="flex mt-5">
          <div className="w-[30%] flex justify-center">
            <ImageTag
              path={`${
                selectedLandlord?.personalInformation?.profileImage?.url ||
                "/assets/daashboard/landlord-color.png"
              }`}
              classes="w-[100px] h-[100px] object-cover rounded-full"
              altText="logo"
            />
          </div>
          <div className="w-[70%] pb-12">
            <div className=" flex">
              <div className="w-[50%]">
                <ParagraphTag
                  content="FIrst Name"
                  classes="text-darkColor font-popinsSemiBold text-[13px]"
                />
                <ParagraphTag
                  content={`${selectedLandlord?.personalInformation?.firstName}`}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="w-[50%]">
                <ParagraphTag
                  content="Last Name"
                  classes="text-darkColor font-popinsSemiBold text-[13px]"
                />
                <ParagraphTag
                  content={`${selectedLandlord?.personalInformation?.lastName}`}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
            </div>
            <div className=" flex pt-2">
              <div className="">
                <ParagraphTag
                  content="Email"
                  classes="text-darkColor font-popinsSemiBold text-[13px]"
                />
                <ParagraphTag
                  content={`${selectedLandlord?.personalInformation?.email} `}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
            </div>
            <div className="pt-2">
              <ParagraphTag
                content="Cell Number"
                classes="text-darkColor font-popinsSemiBold text-[13px]"
              />
              <ParagraphTag
                content={`${selectedLandlord?.personalInformation?.phoneNumber}`}
                classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
              />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-xl mt-3 py-3">
        <div className="w-[49%] bg-white rounded-xl">
          <div className="px-4 pt-4 flex justify-between items-center">
            <ParagraphTag
              content="Subscription Information"
              classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
            />
            {/* <ParagraphTag
              content={"View All"}
              classes="text-themeColor font-popinsSemiBold text-sm cursor-pointer"
              onTrigger={() => onAction("Payment")}
            /> */}
          </div>
          <div className="flex mt-1 items-center pl-6 mb-5">
            <div className="w-[70%]">
              <div className="pt-3">
                <ParagraphTag
                  content="Plan Name"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={
                    selectedLandlord?.subscriptionPackage[0]?.packageData
                      ?.planName
                  }
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="pt-3">
                <ParagraphTag
                  content="Plan End Date"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={moment(
                    selectedLandlord?.subscriptionPackage[0]?.endDate
                  ).format("MM/DD/YY")}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="pt-2">
                <ParagraphTag
                  content="Allowed Properties"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={sumByKey(
                    selectedLandlord?.subscriptionPackage,
                    "allowProperties"
                  )}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedLandlord?.isAppeal && (
        <div className="bg-white rounded-xl mt-3 py-3">
          <div className="flex items-center justify-center pt-2">
            <ParagraphTag
              content="Landlord Appeal"
              classes="text-darkColor font-popinsSemiBold text-[15px]"
            />
          </div>
          <div className="w-[95%] mx-auto flex mt-2 py-[10px] px-2  justify-between items-center rounded-md">
            <div className="text-end flex flex-col justify-center pr-3">
              <ParagraphTag
                content={selectedLandlord?.appealRequest}
                classes={`text-darkColor font-popinsregular p-1 text-sm `}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandlordInfo;
